import React, { useEffect, useMemo, useState } from 'react';
import MaterialTable from 'material-table';
import { Button } from 'react-bootstrap';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import { styledTable, styledTableHeading, tableIcons } from '../../../helpers';
import useAPI from '../../../hooks/useAPI';
import {
  localization, modifyDefaultOptions, options, tableIconsModified,
} from '../../../helpers/table';
import { useAPIBudgetCode } from '../adminApiService';

export default function TabBudgetCode() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  const api = useAPI();
  const [getData, saveData, removeData] = useMemo(() => useAPIBudgetCode(api), [api]);

  useEffect(async () => {
    const result = await getData();
    setIsLoaded(true);
    setData(result);
  }, []);

  const handleSaveData = async (entry) => {
    const resp = await saveData(entry);
    if (!resp || resp.error) return null;
    return resp;
  };

  const handleRemoveData = async (entry) => {
    const resp = await removeData(entry);
    if (!resp || resp.error) return null;
    return resp;
  };

  const columns = [
    { title: 'Наименование', field: 'name', filterCellStyle: { minWidth: '600px' } },
    { title: 'Код полный', field: 'fullCode' },
    { title: 'Код краткий', field: 'code' },
  ];

  if (!isLoaded) {
    return <section className="tab-agreement-plan"><div>Загрузка...</div></section>;
  } return (
    <section className="tab-budget-code">
      <div style={styledTable}>
        <MaterialTable
          title={<h3 style={styledTableHeading}>Код по бюджетной классификации</h3>}
          options={modifyDefaultOptions({
            actionsColumnIndex: -1,
            addRowPosition: 'first',
          })}
          icons={tableIconsModified}
          editable={{
            onRowAdd: (newData) =>
              new Promise(async (resolve, reject) => {
                // setData([...data, newData]);
                const resp = await handleSaveData(newData);
                if (resp) await setData((prev) => [resp, ...prev]);
                resolve();
              }),
            onRowUpdate: (newData, oldData) =>
              new Promise(async (resolve, reject) => {
                const resp = await handleSaveData(newData);
                if (resp) await setData((prev) => prev.map((v) => (v.id === resp.id ? resp : v)));
                resolve();
              }),
            onRowDelete: (oldData) =>
              new Promise(async (resolve, reject) => {
                const resp = await handleRemoveData(oldData);
                if (resp) await setData((prev) => prev.filter((v) => v.id !== oldData.id));
                resolve();
              }),
          }}
          localization={localization}
          columns={columns}
          data={data}
        />
      </div>
    </section>
  );
}
